import React, { useEffect, useMemo, useState } from 'react'
import { Button, Card } from 'react-bootstrap'
import { FormCustom, Input } from '../../../components/form'
import { doRequestPost } from '../../../api'
import { toast } from 'react-toastify'
import { doToast, getDate } from '../../../utils'
import LoadingIcon from '../../../components/loading/LoadingIcon'
import { Html5QrcodeScanner } from "html5-qrcode";
import { useGet } from '../../../hooks/process-data'
import ReactTableBootstrap from 'react-table-bootstrap'

export const EscanerView = () => {
  const [search, setSearch] = useState('')
  const [response, setResponse] = useState({})
  const [loading, setLoading] = useState(false)

  const [form, setForm] = useState({
    p_date_start: getDate(),
    p_date_end: getDate(),
  })

  const [execute, setExecute] = useState(false)
  const { rows, isProcessing, setReload, error, setError, setRows } = useGet({
    url: `/event/report/escaner/${form.p_date_start}/${form.p_date_end}`,
    execute
  })

  const requestCameraPermission = () => {
    let html5QrcodeScanner = new Html5QrcodeScanner(
      "reader",
      { fps: 10, qrbox: { width: 250, height: 250 } }, false);
    html5QrcodeScanner.render((decodedText) => {
      setSearch(decodedText)
    }, _ => { });

    setTimeout(() => {
      document.getElementById('camera_container').classList.add('d-flex')
      document.getElementById('camera_container').classList.add('justify-content-center')
    }, 500)

    return () => {
      html5QrcodeScanner.clear();
    }
  }

  useEffect(() => {
    return requestCameraPermission()
  }, [])

  const dtRows = useMemo(() => {
    return <ReactTableBootstrap
      head={[[
        { name: 'date_scan', text: 'Nombre', align: 'center' },
        { name: 'full_name', text: 'Tipo Evento', align: 'center' },
        { name: 'date_evenname_eventt', text: 'Fecha', align: 'center', render: r => {
          return <div>
            <div>{r.name_event}</div>
            <div>{r.name_event_zone}</div>
            <div>{r.row_column}</div>
          </div>
        } },
      ]]}
      rows={rows}
      isProcessing={isProcessing}
    />
  }, [rows, isProcessing])

  return <div className='row' style={{
    paddingTop: 80
  }}>
    <div className="col-xl-2 col-lg-1"></div>
    <div className="col-xl-8 col-lg-10">
      <Card>
        <Card.Body>
          <div id="camera_container" className="w-100">
            <div style={{
              maxWidth: '300px',
            }} className='mb-4'>
              <div id="reader"></div>
            </div>
          </div>
          <FormCustom viewSubmit={false} onSubmit={async () => {
            try {
              setLoading(true)
              setResponse({})

              const scanQr = await doRequestPost({
                url: '/event/escaner',
                data: {
                  p_search: search
                }
              })

              if (scanQr.response === 'success') {
                setResponse({
                  ...scanQr.data,
                  type: scanQr.response,
                  message: scanQr.message
                })
              } else {
                setResponse({
                  type: scanQr.response,
                  message: scanQr.message
                })
              }
            } catch (error) {
              doToast({
                message: 'No se pudo escanear el código QR',
                response: 'error',
                toast
              })
              setResponse({})
            } finally {
              setSearch('')
              document.getElementById('txt_search').focus()
              setLoading(false)
            }
          }}>
            <Input
              text="Escanea el código QR"
              size="lg"
              required
              value={search}
              onChange={e => setSearch(e.target.value)}
              append={[
                <Button variant="primary" type="submit">
                  <i className="fas fa-qrcode"></i>
                </Button>
              ]}
              id="txt_search"
              autoFocus
              disabled
            />
          </FormCustom>

          {response.hasOwnProperty('type') && <div className={`alert alert-${response.type} mt-4 text-center`} role="alert">
            <div>
              <strong>
                {response.message}
              </strong>
            </div>
            {response.type === 'success' && <>
              <div>
                <strong>Evento: {response.name_event}</strong>
              </div>
              <div>
                <strong>Nombres: {response.full_name}</strong>
              </div>
            </>}
          </div>}
        </Card.Body>
      </Card>

      {loading && <LoadingIcon />}
    </div>
    <div className="col-xl-2 col-lg-1"></div>
    <div className="col-xl-2 col-lg-1"></div>
    <div className="col-xl-8 col-lg-10 mt-4">
      <Card>
        <Card.Body>
          <FormCustom onSubmit={_ => {
            setReload(true)
            setExecute(true)
          }} viewSubmit={false}>
            <Input
              classNameParent="col-md-6 mb-2"
              value={form.p_date_start}
              onChange={e => setForm({ ...form, p_date_start: e.target.value })}
              type="date"
              text="Fecha Inicio"
            />
            <Input
              classNameParent="col-md-6 mb-2"
              value={form.p_date_end}
              onChange={e => setForm({ ...form, p_date_end: e.target.value })}
              type="date"
              text="Fecha Fin"
              append={[
                <Button type="submit">
                  <i className='fa fa-search'></i>
                </Button>
              ]}
            />
          </FormCustom>
          {dtRows}
        </Card.Body>
      </Card>

      {loading && <LoadingIcon />}
    </div>
  </div >
}